<template>
  <div class="container no-padding">
    <div class="klickpages-link">
      <div class="kp-folder-table-title">
        <div class="kp-folder-name">{{ $t('account.attributes.name') }}</div>
        <div class="kp-folder-updatedate">{{ $t('account.attributes.type') }}</div>
        <div class="kp-folder-updatedate">{{ $t('account.list.insert_date') }}</div>
        <div class="kp-folder-actions">{{ $t('account.list.actions') }}</div>
      </div>

      <div ui-tree-handle="" folder-drop="afterDrop" class="kp-list-item" v-if="hasSend || accountList.length > 0">
        <item v-if="hasSend" :account="sendAccount" ></item>
        <item v-for="item in accountList" :key="item.id" :account="item"></item>
      </div>

      <div v-if="!hasSend && accountList.length == 0">
        <empty-board></empty-board>
      </div>
    </div>

    <edit-account></edit-account>
    <delete-account></delete-account>
  </div>
</template>

<script>
import cookie from 'js-cookie';
import { mapGetters, mapActions } from 'vuex';
import Item from './Item';
import EmptyBoard from './EmptyBoard';
import EditAccount from './EditAccount';
import DeleteAccount from './DeleteAccount';

export default {
  mounted() {
    this.getAccounts();
  },
  components: {
    Item,
    EmptyBoard,
    EditAccount,
    DeleteAccount,
  },
  methods: {
    ...mapActions({
      getAccounts: 'account/get',
      addAccount: 'account/add',
    }),
  },
  computed: {
    ...mapGetters({
      accountList: 'account/list',
    }),
    hasSend() {
      try {
        const token = cookie.get('user-auth-token');
        const decryptedToken = JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
        const hasSend = decryptedToken.permissions.klicksendEnabled;
        return hasSend;
      } catch (error) {
        return false;
      }
    },
    sendAccount() {
      return { name: 'Hotmart Send', type: 'Hotmart Send' };
    },
  },
};
</script>



// WEBPACK FOOTER //
// List.vue?0c9e7670